import { useEffect } from 'react';
import { useStore } from 'react-redux';

import { setupAuditInterceptor } from '@britishcouncil/react-common';
import {
  include401Interceptor,
  includeAuthInterceptor,
  OidcContext,
} from '@britishcouncil/react-oidc-auth';

import { axios as authAxios } from 'api/auth/custom-auth-api';
import { axios as planningAxios } from 'api/planning';
import { axios as reportsAxios } from 'api/reports';
import {
  includeApiValidationErrorInterceptor,
  setupSentryInterceptor,
  includeNavigationContextInterceptor,
} from 'core';
import { useAppSettings } from 'settings';
import { RootState } from 'store';

export const Interceptors = ({ children }: { children: React.ReactNode }) => {
  const store = useStore<RootState>();
  const { userManagerSettings } = useAppSettings();
  const { signoutRedirect } = OidcContext.useAuth();

  useEffect(() => {
    // PLANNING API
    includeAuthInterceptor(planningAxios, undefined, userManagerSettings);
    include401Interceptor(planningAxios, signoutRedirect);
    setupAuditInterceptor(planningAxios);
    setupSentryInterceptor(planningAxios);
    includeApiValidationErrorInterceptor(planningAxios);
    includeNavigationContextInterceptor(planningAxios, store);

    // AUTH API
    includeAuthInterceptor(authAxios, undefined, userManagerSettings);
    include401Interceptor(authAxios, signoutRedirect);
    setupAuditInterceptor(authAxios);
    setupSentryInterceptor(authAxios);
    includeApiValidationErrorInterceptor(authAxios);

    // REPORTS API
    includeAuthInterceptor(reportsAxios, undefined, userManagerSettings);
    include401Interceptor(reportsAxios, signoutRedirect);
    setupAuditInterceptor(reportsAxios);
    setupSentryInterceptor(reportsAxios);
    includeApiValidationErrorInterceptor(reportsAxios);
    includeNavigationContextInterceptor(reportsAxios, store);
  }, [signoutRedirect, store, userManagerSettings]);

  return <>{children}</>;
};
